
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGtm from '@gtm-support/vue2-gtm'
import VueSocialSharing from 'vue-social-sharing'
import VueShepherd from 'vue-shepherd'
import config from '@/shared/config'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

require('spark-bootstrap')

require('./components/bootstrap')

Sentry.init({
  Vue,
  dsn: 'https://d849819c107c41568c9a667aefba1fec@o969111.ingest.sentry.io/5923804',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'sirius.test', 'test.sirius.dev', /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  logErrors: true
})

const app = new Vue({
  data: {
    loaded: false
  },
  mounted () {
    this.loaded = true
  },
  mixins: [require('spark')],
  methods: {
    loadDataForAuthenticatedUser () {
      if (Spark.state.user.email_verified_at !== null) {
        this.getNotifications()
      }
    }
  },
  components: {
    'nav-container': () => import('./components/layouts/nav-container'),
    'nav-public': () => import('./components/layouts/nav-public'),
    'nav-dev': () => import('./components/layouts/nav-dev'),
    'nav-recruiter': () => import('./components/layouts/nav-recruiter'),
    'verify-email': () => import('./components/shared/verify-email'),
    home: () => import('./components/home'),
    'dev-profile': () => import('./components/dev/profile'),
    'dev-register': () => import('./components/dev/register'),
    'how-it-works': () => import('./components/public/how-it-works'),
    'sirius-news': () => import('./components/public/sirius-news')
  }
})

// Initialise GTM
Vue.use(VueGtm, {
  id: 'GTM-MKK69SG', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: false // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
})

Vue.use(VueSweetalert2, config.notificationSettings)

Vue.use(VueSocialSharing)
Vue.use(VueShepherd)

if (typeof $crisp !== 'undefined') {
  $crisp.push(['safe', true])
}
